module.exports = __webpack_public_path__ + "img/hazardEquip05.1d837443.jpg";